import React, { useEffect, useState } from "react";
import img1 from "../../Images/q1.png";
import img2 from "../../Images/q2.png";
import img3 from "../../Images/q3.png";
import pic1 from "../../Images/Picture1.jpg";
import pic2 from "../../Images/Picture2.png";
import pic3 from "../../Images/Picture3.png";
import { Link } from "react-router-dom";
import qr1 from "../../Images/qr1.png";
import qr2 from "../../Images/qr2.png";
import qr3 from "../../Images/qr3.png";
import qr4 from "../../Images/qr4.png";
export default function Index() {
  const [data, setData] = useState([]);
  const [types, setTypes] = useState([
    "Executive",
    "Visionary",
    "Voyager",
    "Explorer",
  ]);
  const [types2, setTypes2] = useState([
    "Transformative Leader",
    "Administrative Leader",
    "Emerging Leader",
  ]);
  const [types3, setTypes3] = useState([
    "Master Actualizer",
    "Transitional Actualizer",
    "Emerging Actualizer",
  ]);
  const [successType, setSuccessType] = useState("");
  const [category, setCategory] = useState("");

  useEffect(() => {
    // if (localStorage.getItem("Type")) {
    //   setCategory(localStorage.getItem("Type"));
    // }

    console.log(localStorage.getItem("Type"));
    setCategory(localStorage.getItem("Type"));
    // if (category === "Second") {

    // } else setTypes(["Executive", "Visionary", "Voyager", "Explorer"]);
    // console.log(localStorage.getItem("score1"));
    // console.log(localStorage.getItem("score2"));
    // console.log(localStorage.getItem("score3"));
    // console.log(localStorage.getItem("score4"));
    // for (let i = 1; i < 5; i++) {
    //   // setTheArray((prevArray) => [...prevArray, newValue]);
    //   setData((data) => [...data, localStorage.getItem(`score${i}`)]);
    //   console.log("arr", localStorage.getItem(`score${i}`));
    // }
    // console.log(data);
    // const arr = [3, 5, 8, 100, 20];

    // const max = Math.max(...arr);

    // const index = arr.indexOf(max);
    // console.log(index); // 👉️ 3
    let one = Number(localStorage.getItem("score1"));
    let two = Number(localStorage.getItem("score2"));
    let three = Number(localStorage.getItem("score3"));
    let four = Number(localStorage.getItem("score4"));

    let data1 = [one, two, three, four];
    setData(data1);
    console.log(data1);
    const maxi = Math.max(...data1);
    console.log(maxi, "max");
    const idx = data1.indexOf(maxi);
    console.log(types[idx], "type");
    console.log(category);
    let cat = localStorage.getItem("Type");
    console.log(cat);
    if (cat == "First") {
      setSuccessType(types[idx]);
    } else if (cat == "Second") {
      setSuccessType(types2[idx].trim());
    } else setSuccessType(types3[idx]);
    // setSuccessType("Emerging Actualizer");
    console.log(successType);
  }, []);
  return (
    <div className=" text-center ">
      {/* <Link to="/">
        <h1 className="color-secondary underline text-xl">Take Quiz again!</h1>
      </Link>
      <br /> */}
      {category == "First" ? (
        <>
          {/* <p className="font-bold underline">
            Your Primary Actualize Leadership is '{successType}'
          </p> */}

          <div className="flex bg-primary flex-row flex-wrap p-2 w-7/12 m-auto justify-between items-center rounded-lg">
            <img src={img1} alt="" className="md:w-5/12 p-2" />

            <div className="bg-white flex flex-col flex-wrap h-full w-full md:w-6/12 m-auto rounded-lg justify-center items-center  md:p-2">
              <br />
              <p className="text-xl decoration-8 font-bold m-4">
                Your Primary Actualize Language is &nbsp;
                <span className=" color-primary">'{successType}'</span>
              </p>

              <br />
            </div>
          </div>
          <br />
          <div className="flex flex-col items-center justify-center m-5">
            <h1 className="text-4xl m-1 font-bold">
              Congratulations you are {successType}
            </h1>
            <br />
            {successType ? (
              <img
                src={require(`../../Images/${successType
                  .split(" ")
                  .join("")}.png`)}
                className="w-3/12 cursor-pointer"
                alt="noo"
              />
            ) : (
              ""
            )}
            <br />

            {successType == "Voyager" ? (
              <p className="text-start">
                <h2 className="text-2xl font-bold color-secondary">
                  THE VOYAGER
                </h2>
                <p className="text-xl color-secondary">Summary</p>
                <ul>
                  <li>
                    {" "}
                    <span className="font-bold"> Strength: </span>Connecting
                    people, high positive energy, and innovation with a high
                    emotional quotient (EQ)
                  </li>
                  <li>
                    {" "}
                    <span className="font-bold"> Weakness: </span> Long-term
                    focus, commitment, follow-through
                  </li>
                </ul>
                <br />
                <h5 className="text-xl">
                  A More In-depth Examination of Your Actualizing Language :
                </h5>
                <h4 className="font-bold">• Cognitive Type</h4>
                <ul>
                  <li>Creative & Artistic</li>
                </ul>
                <h4 className="font-bold">• Emotive Type</h4>
                <ul>
                  <li>Connector</li>
                </ul>
                <h4 className="font-bold">• Agitation Type:</h4>
                <ul>
                  <li>Shutdown and hold the grudge </li>
                </ul>
                <h4 className="font-bold">• Service Type:</h4>
                <ul>
                  <li>
                    Type 1, Creatives – musicians, artistic, fashion, culinary
                    arts, media
                  </li>
                  <li>
                    Type 2, Front office – marketing, customer service, human
                    resources
                  </li>
                </ul>
              </p>
            ) : successType == "Explorer" ? (
              <p className="text-start">
                <h2 className="text-2xl font-bold color-secondary">
                  THE EXPLORER
                </h2>
                <p className="text-xl color-secondary">Summary</p>
                <ul>
                  <li>
                    {" "}
                    <span className="font-bold"> Strength: </span>Interpersonal
                    relationships, harmony, and team leadership with ample
                    intelligence quotient (IQ) and emotional quotient (EQ)
                  </li>
                  <li>
                    {" "}
                    <span className="font-bold"> Weakness: </span>{" "}
                    procrastination, passive, and self-righteousness.
                  </li>
                </ul>
                <br />
                <h5 className="text-xl">
                  A More In-depth Examination of Your Actualizing Language :
                </h5>
                <h4 className="font-bold">• Cognitive Type</h4>
                <ul>
                  <li>Intuitive</li>
                </ul>
                <h4 className="font-bold">• Emotive Type</h4>
                <ul>
                  <li>Reflective</li>
                </ul>
                <h4 className="font-bold">• Agitation Type:</h4>
                <ul>
                  <li>Shutdown and Revenge </li>
                </ul>
                <h4 className="font-bold">• Service Type:</h4>
                <ul>
                  <li>Type 1, Problem solvers – Mechanics, Engineers, Techs</li>
                  <li>Type 2, Instinctive – Counselors, Chaplains, Advisors</li>
                </ul>
              </p>
            ) : successType == "Executive" ? (
              <p className="text-start">
                <h2 className="text-2xl font-bold color-secondary">
                  THE EXECUTIVE
                </h2>
                <p className="text-xl color-secondary">Summary</p>
                <ul>
                  <li>
                    {" "}
                    <span className="font-bold"> Strength: </span>analytical,
                    administrative, and organized with a balance of ample
                    intelligence quotient (IQ) and emotional quotient (EQ)
                  </li>
                  <li>
                    {" "}
                    <span className="font-bold"> Weakness: </span> anxiety,
                    perfectionism, and moodiness.
                  </li>
                </ul>
                <br />
                <h5 className="text-xl">
                  A More In-depth Examination of Your Actualizing Language :
                </h5>
                <h4 className="font-bold">• Cognitive Type</h4>
                <ul>
                  <li>Analyst</li>
                </ul>
                <h4 className="font-bold">• Emotive Type</h4>
                <ul>
                  <li>Function</li>
                </ul>
                <h4 className="font-bold">• Agitation Type:</h4>
                <ul>
                  <li>Moody, Prickly, and Controlling </li>
                </ul>
                <h4 className="font-bold">• Service Type:</h4>
                <ul>
                  <li>Type 1, Manager - Supervisor, Department Lead</li>
                  <li>
                    Type 2, Intuitive - Counselors, Chaplains, Therapists,
                    Advisor
                  </li>
                </ul>
              </p>
            ) : (
              <p className="text-start">
                <h2 className="text-2xl font-bold color-secondary">
                  THE VISIONARY
                </h2>
                <p className="text-xl color-secondary">Summary</p>
                <ul>
                  <li>
                    {" "}
                    <span className="font-bold"> Strength: </span>leadership,
                    visionary and logical thinking with a high intelligent
                    quotient (IQ)
                  </li>
                  <li>
                    {" "}
                    <span className="font-bold"> Weakness: </span> anxious,
                    argumentative with a low emotional quotient (EQ)
                  </li>
                </ul>
                <br />
                <h5 className="text-xl">
                  A More In-depth Examination of Your Actualizing Language :
                </h5>
                <h4 className="font-bold">• Cognitive Type</h4>
                <ul>
                  <li>Logician</li>
                </ul>
                <h4 className="font-bold">• Emotive Type</h4>
                <ul>
                  <li>Transactive</li>
                </ul>
                <h4 className="font-bold">• Agitation Type:</h4>
                <ul>
                  <li>o Short and Explosive </li>
                </ul>
                <h4 className="font-bold">• Service Type:</h4>
                <ul>
                  <li>
                    Type 1, Leadership - Chief Executives, Administrators,
                    Generals
                  </li>
                  <li>Type 2, Founder - Inventors, Entrepreneurs, Pioneers</li>
                </ul>
              </p>
            )}
          </div>
          <br />
          <div className="flex flex-row  items-center justify-center w-100 m-3  flex-wrap wrap">
            <div className="w-8/12 flex flex-row flex-wrap items-center justify-center">
              <div className="w-4/12 bg-red-200">
                <img src={pic2} alt="" className="" />
              </div>
              <div className="w-7/12 text-start p-4 m-5">
                <h1 className="text-xl md:text-5xl font-bold">
                  To receive detailed knowledge of your results, get The Four
                  Actualize Languages
                </h1>
                <h3 className="color-secondary font-bold text-3xl my-3">
                  The 4 Actualize Languages
                </h3>

                <p className="text-xl">
                  Your Actualize Language opens doors to understanding yourself
                  better, develops your leadership capacity, and builds
                  effective networks.
                </p>
                <a
                  href="https://www.actualizecenter.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn-discover p-4 w-32 my-3  bg-green-600 rounded-xl text-white font-bold text-xl">
                    Discover
                  </button>
                </a>
              </div>
            </div>
          </div>
          <br />
        </>
      ) : category == "Second" ? (
        <>
          {/* <p className="font-bold underline">
            Your Primary Actualize Leadership is '{successType}'
          </p> */}

          <div className="flex bg-secondary flex-row flex-wrap p-2 w-7/12 m-auto justify-between items-center rounded-lg">
            <img src={img2} alt="" className="md:w-5/12 p-2" />

            <div className="bg-white flex flex-col flex-wrap h-full w-full md:w-6/12 m-auto rounded-lg justify-center items-center  md:p-2">
              <br />
              <p className="text-xl decoration-8 font-bold m-4">
                Your Primary Actualize Leadership is{" "}
                <span className=" color-secondary">'{successType}'</span>
              </p>

              <br />
            </div>
          </div>
          <br />
          <div className="flex flex-col items-center justify-center m-5">
            <h1 className="text-4xl m-1 font-bold">
              Congratulations you are {successType}
            </h1>
            <br />
            {successType ? (
              <img
                src={require(`../../Images/${successType
                  .split(" ")
                  .join("")}.jpg`)}
                className="w-2/12 cursor-pointer"
                alt="noo"
              />
            ) : (
              ""
            )}
            <br />
            {successType == "Transformative Leader" ? (
              <p className="text-start">
                <h2 className="text-xl font-bold">
                  TRANSFORMATIVE LEADER QUALITIES
                </h2>
                <h4 className="font-bold">Strengths:</h4>
                <ul className="text-lg">
                  <li>Visionary</li>
                  <li>Experience</li>
                  <li>Influence</li>
                </ul>
                <h4 className="font-bold">Improvements:</h4>
                <ul className="text-lg">
                  <li>Self-Protection</li>
                  <li>Legacy Building</li>
                </ul>
              </p>
            ) : successType == "Administrative Leader" ? (
              <p className="text-start">
                <h2 className="text-xl font-bold">
                  TRANSITIONAL LEADER QUALITIES
                </h2>
                <h4 className="font-bold">Strengths:</h4>
                <ul>
                  <li>Influence</li>
                  <li>Administration and Management</li>
                </ul>
                <h4 className="font-bold">Improvements:</h4>
                <ul>
                  <li>Vision Building</li>
                  <li>Personal Development and Coaching</li>
                </ul>
              </p>
            ) : (
              <p className="text-start p-3">
                <h2 className="text-3xl font-bold p-2">
                  EMERGENT LEADER QUALITIES
                </h2>
                <h4 className="font-bold text-2xl p-2">Strengths:</h4>
                <ul>
                  <li className="text-xl">Openness to Growth</li>
                </ul>
                <h4 className="font-bold text-2xl p-2">Improvements:</h4>
                <ul className="text-xl">
                  <li>Personal Development</li>
                  <li>Mentorship</li>
                  <li>Knowledge</li>
                </ul>
              </p>
            )}
          </div>
          <br />
          <div className="flex flex-row  items-center justify-center w-100 m-3  flex-wrap wrap">
            <div className="w-8/12 flex flex-row flex-wrap items-center justify-center">
              <div className="w-4/12 bg-red-200">
                <img src={pic3} alt="" className="" />
              </div>
              <div className="w-7/12 text-start p-4 m-5">
                <h1 className="text-xl md:text-5xl font-bold">
                  To receive detailed knowledge of your results, get Actualize
                  Leader
                </h1>
                <h3 className="color-secondary font-bold text-3xl my-3">
                  Actualize Leader
                </h3>
                <h4 className="font-bold text-xl md:text-3xl">
                  Developing the Coach Leader in You
                </h4>
                <p className="text-xl">
                  This guide will train you on how to develop the coach leader
                  in you. 
                </p>
                <a
                  href="https://www.actualizecenter.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn-discover p-4 w-32 my-3  bg-green-600 rounded-xl text-white font-bold text-xl">
                    Discover
                  </button>
                </a>
              </div>
            </div>
          </div>
          <br />
        </>
      ) : (
        <>
          {/* <p className="font-bold underline">
            Your Primary Actualize Leadership is '{successType}'
          </p> */}

          <div className="flex bg-purple flex-row flex-wrap p-2 w-7/12 m-auto justify-between items-center rounded-lg">
            <img src={img3} alt="" className="md:w-5/12 p-2" />

            <div className="bg-white flex flex-col flex-wrap h-full w-full md:w-6/12 m-auto rounded-lg justify-center items-center  md:p-2">
              <br />
              <p className="text-xl decoration-8 font-bold m-4">
                Your Primary Actualize Purpose is &nbsp;
                <span className=" color-purple">'{successType}'</span>
              </p>

              <br />
            </div>
          </div>
          <br />
          <div className="flex flex-col items-center justify-center m-5">
            <h1 className="text-4xl m-1 font-bold">
              Congratulations you are {successType}
            </h1>
            <br />
            {successType ? (
              <img
                src={require(`../../Images/${successType
                  .split(" ")
                  .join("")}.jpg`)}
                className="w-2/12 cursor-pointer"
                alt="noo"
              />
            ) : (
              ""
            )}
            <br />

            {successType == "Emerging Actualizer" ? (
              <p className="text-start">
                <h2 className="text-xl font-bold">Emerging Actualizer</h2>
                <h4 className="font-bold">Strengths:</h4>
                <ul className="text-lg">
                  <li>Potential</li>
                  <li>Room for growth</li>
                </ul>
                <h4 className="font-bold">Improvements:</h4>
                <ul className="text-lg">
                  <li>Mentorship</li>
                  <li>Training</li>
                </ul>
              </p>
            ) : successType == "Transitional Actualizer" ? (
              <p className="text-start">
                <h2 className="text-xl font-bold">Transitional Actualizer</h2>
                <h4 className="font-bold">Strengths:</h4>
                <ul>
                  <li>Experience</li>
                </ul>
                <h4 className="font-bold">Improvements:</h4>
                <ul>
                  <li>Mentors to make the right next choice</li>
                  <li>Work out your purpose in life</li>
                  <li>Your vision goals</li>
                </ul>
              </p>
            ) : (
              <p className="text-start p-3">
                <h2 className="text-3xl font-bold p-2">
                  Transformative Actualizer
                </h2>
                <h4 className="font-bold text-2xl p-2">Strengths:</h4>
                <ul>
                  <li className="text-xl">High level of purpose in life and</li>
                  <li>High level of leadership</li>
                </ul>
                <h4 className="font-bold text-2xl p-2">Improvements:</h4>
                <ul className="text-xl">
                  <li>Build a legacy</li>
                  <li>Sustain your level of purpose</li>
                  <li>Not allowing your mind to retire</li>
                </ul>
              </p>
            )}
          </div>
          <br />
          <div className="flex flex-row  items-center justify-center w-100 m-3  flex-wrap wrap">
            <div className="w-8/12 flex flex-row flex-wrap items-center justify-center">
              <div className="w-4/12 bg-red-200">
                <img src={pic1} alt="" className="" />
              </div>
              <div className="w-7/12 text-start p-4 m-5">
                <h1 className="text-xl md:text-5xl font-bold">
                  To receive detailed knowledge of your results, get Actualize
                  Purpose
                </h1>
                <h3 className="color-secondary font-bold text-3xl my-3">
                  Actualize Purpose
                </h3>
                <h4 className="font-bold text-xl md:text-3xl">
                  Through the Threshing Floor
                </h4>
                <p className="text-xl">
                  This guide will walk you through the challenges and conflicts
                  in life to discovering and living a life in purpose. 
                </p>
                <a
                  href="https://www.actualizecenter.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="btn-discover p-4 w-32 my-3  bg-green-600 rounded-xl text-white font-bold text-xl">
                    Discover
                  </button>
                </a>
              </div>
            </div>
          </div>
          <br />
        </>
      )}
      {/* <br />
      <Link to="/">
        <h1 className="color-secondary underline text-xl">Take Quiz again!</h1>
      </Link>
      <br /> */}
    </div>
  );
}
